export default {
  blockPriceVariations: [],
  blockPricePaymentTokens: [],
}
